// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos generales para el POS */

:root {
  --primary-color: #0066CC;
  --secondary-color: #004499;
  --success-color: #28A745;
  --warning-color: #FFC107;
  --danger-color: #DC3545;
  --info-color: #17A2B8;
  --light-color: #F8F9FA;
  --dark-color: #343A40;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
}

/* Estilos para el login */
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  border-radius: 15px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  background: white;
}

.login-card .card-body {
  padding: 2.5rem;
}

.form-control-lg {
  border-radius: 10px;
  border: 2px solid #e9ecef;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control-lg:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 102, 204, 0.25);
  outline: none;
}

.btn-lg {
  border-radius: 10px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.btn-lg:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos para el dashboard */
.sidebar {
  background-color: #ffffff;
  border-right: 1px solid #dee2e6;
  min-height: calc(100vh - 56px);
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
}

.sidebar-content {
  padding: 1rem 0;
}

.sidebar-item {
  padding: 0.75rem 1.5rem;
  color: #495057;
  text-decoration: none;
  border-radius: 0;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.sidebar-item:hover {
  background-color: #e9ecef;
  color: var(--primary-color);
  border-left-color: var(--primary-color);
}

.sidebar-item.active {
  background-color: var(--primary-color);
  color: white;
  border-left-color: var(--secondary-color);
}

.sidebar-item i {
  width: 20px;
  text-align: center;
}

.main-content {
  background-color: #f8f9fa;
  min-height: calc(100vh - 56px);
}

.content-wrapper {
  padding: 2rem;
}

/* Estilos para tarjetas */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card-header {
  border-radius: 10px 10px 0 0 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

/* Estilos para tablas */
.table {
  margin-bottom: 0;
}

.table th {
  border-top: none;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  color: #6c757d;
  background-color: #f8f9fa;
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 102, 204, 0.05);
}

/* Estilos para botones */
.btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.btn-primary:hover {
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
}

.btn-success {
  background-color: var(--success-color);
  border-color: var(--success-color);
}

.btn-danger {
  background-color: var(--danger-color);
  border-color: var(--danger-color);
}

.btn-warning {
  background-color: var(--warning-color);
  border-color: var(--warning-color);
  color: #212529;
}

.btn-info {
  background-color: var(--info-color);
  border-color: var(--info-color);
}

/* Estilos para formularios */
.form-control, .form-select {
  border-radius: 8px;
  border: 1px solid #ced4da;
  transition: all 0.3s ease;
}

.form-control:focus, .form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 102, 204, 0.25);
}

/* Estilos para el punto de venta */
.product-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.product-card .card-body {
  padding: 1rem;
}

.cart-item {
  border-radius: 8px;
  margin-bottom: 0.5rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
}

/* Estilos para estadísticas */
.stat-card {
  border-radius: 15px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 1rem;
  }
  
  .sidebar {
    position: fixed;
    top: 56px;
    left: -100%;
    width: 280px;
    height: calc(100vh - 56px);
    z-index: 1000;
    transition: left 0.3s ease;
    background: white;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .sidebar.show {
    left: 0;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .login-card {
    margin: 1rem;
  }
  
  .login-card .card-body {
    padding: 1.5rem;
  }
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out;
}

/* Estilos para impresión */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-only {
    display: block !important;
  }
  
  body {
    font-size: 12px;
    line-height: 1.2;
  }
  
  .card {
    box-shadow: none;
    border: 1px solid #000;
  }
}

/* Estilos personalizados para SweetAlert2 */
.swal2-popup {
  border-radius: 15px !important;
}

.swal2-title {
  color: var(--dark-color) !important;
  font-size: 1.5rem !important;
}

.swal2-html-container {
  color: #6c757d !important;
}

.swal2-confirm {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

/* Utilidades adicionales */
.text-primary {
  color: var(--primary-color) !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.border-primary {
  border-color: var(--primary-color) !important;
}

.text-success {
  color: var(--success-color) !important;
}

.bg-success {
  background-color: var(--success-color) !important;
}

.text-danger {
  color: var(--danger-color) !important;
}

.bg-danger {
  background-color: var(--danger-color) !important;
}

.text-warning {
  color: var(--warning-color) !important;
}

.bg-warning {
  background-color: var(--warning-color) !important;
}

.text-info {
  color: var(--info-color) !important;
}

.bg-info {
  background-color: var(--info-color) !important;
}

/* Sombras personalizadas */
.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.shadow {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1) !important;
}

/* Bordes redondeados */
.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.5rem !important;
}

.rounded-lg {
  border-radius: 1rem !important;
}

.rounded-xl {
  border-radius: 1.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yFAAyF;EACzF,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,4CAA4C;AAC5C;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Estilos generales para el POS */\n\n:root {\n  --primary-color: #0066CC;\n  --secondary-color: #004499;\n  --success-color: #28A745;\n  --warning-color: #FFC107;\n  --danger-color: #DC3545;\n  --info-color: #17A2B8;\n  --light-color: #F8F9FA;\n  --dark-color: #343A40;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f8f9fa;\n}\n\n/* Estilos para el login */\n.bg-gradient-primary {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-card {\n  border-radius: 15px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  background: white;\n}\n\n.login-card .card-body {\n  padding: 2.5rem;\n}\n\n.form-control-lg {\n  border-radius: 10px;\n  border: 2px solid #e9ecef;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.form-control-lg:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 0.2rem rgba(0, 102, 204, 0.25);\n  outline: none;\n}\n\n.btn-lg {\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n}\n\n.btn-lg:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Estilos para el dashboard */\n.sidebar {\n  background-color: #ffffff;\n  border-right: 1px solid #dee2e6;\n  min-height: calc(100vh - 56px);\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-content {\n  padding: 1rem 0;\n}\n\n.sidebar-item {\n  padding: 0.75rem 1.5rem;\n  color: #495057;\n  text-decoration: none;\n  border-radius: 0;\n  border-left: 3px solid transparent;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar-item:hover {\n  background-color: #e9ecef;\n  color: var(--primary-color);\n  border-left-color: var(--primary-color);\n}\n\n.sidebar-item.active {\n  background-color: var(--primary-color);\n  color: white;\n  border-left-color: var(--secondary-color);\n}\n\n.sidebar-item i {\n  width: 20px;\n  text-align: center;\n}\n\n.main-content {\n  background-color: #f8f9fa;\n  min-height: calc(100vh - 56px);\n}\n\n.content-wrapper {\n  padding: 2rem;\n}\n\n/* Estilos para tarjetas */\n.card {\n  border: none;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.card-header {\n  border-radius: 10px 10px 0 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n/* Estilos para tablas */\n.table {\n  margin-bottom: 0;\n}\n\n.table th {\n  border-top: none;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  letter-spacing: 0.5px;\n  color: #6c757d;\n  background-color: #f8f9fa;\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 102, 204, 0.05);\n}\n\n/* Estilos para botones */\n.btn {\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.btn-primary:hover {\n  background-color: var(--secondary-color);\n  border-color: var(--secondary-color);\n}\n\n.btn-success {\n  background-color: var(--success-color);\n  border-color: var(--success-color);\n}\n\n.btn-danger {\n  background-color: var(--danger-color);\n  border-color: var(--danger-color);\n}\n\n.btn-warning {\n  background-color: var(--warning-color);\n  border-color: var(--warning-color);\n  color: #212529;\n}\n\n.btn-info {\n  background-color: var(--info-color);\n  border-color: var(--info-color);\n}\n\n/* Estilos para formularios */\n.form-control, .form-select {\n  border-radius: 8px;\n  border: 1px solid #ced4da;\n  transition: all 0.3s ease;\n}\n\n.form-control:focus, .form-select:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 0.2rem rgba(0, 102, 204, 0.25);\n}\n\n/* Estilos para el punto de venta */\n.product-card {\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.product-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.product-card .card-body {\n  padding: 1rem;\n}\n\n.cart-item {\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  background-color: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.quantity-btn {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-weight: bold;\n}\n\n/* Estilos para estadísticas */\n.stat-card {\n  border-radius: 15px;\n  background: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n}\n\n/* Estilos responsivos */\n@media (max-width: 768px) {\n  .content-wrapper {\n    padding: 1rem;\n  }\n  \n  .sidebar {\n    position: fixed;\n    top: 56px;\n    left: -100%;\n    width: 280px;\n    height: calc(100vh - 56px);\n    z-index: 1000;\n    transition: left 0.3s ease;\n    background: white;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .sidebar.show {\n    left: 0;\n  }\n  \n  .main-content {\n    margin-left: 0;\n  }\n  \n  .login-card {\n    margin: 1rem;\n  }\n  \n  .login-card .card-body {\n    padding: 1.5rem;\n  }\n}\n\n/* Animaciones */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Estilos para impresión */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-only {\n    display: block !important;\n  }\n  \n  body {\n    font-size: 12px;\n    line-height: 1.2;\n  }\n  \n  .card {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n}\n\n/* Estilos personalizados para SweetAlert2 */\n.swal2-popup {\n  border-radius: 15px !important;\n}\n\n.swal2-title {\n  color: var(--dark-color) !important;\n  font-size: 1.5rem !important;\n}\n\n.swal2-html-container {\n  color: #6c757d !important;\n}\n\n.swal2-confirm {\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n}\n\n/* Utilidades adicionales */\n.text-primary {\n  color: var(--primary-color) !important;\n}\n\n.bg-primary {\n  background-color: var(--primary-color) !important;\n}\n\n.border-primary {\n  border-color: var(--primary-color) !important;\n}\n\n.text-success {\n  color: var(--success-color) !important;\n}\n\n.bg-success {\n  background-color: var(--success-color) !important;\n}\n\n.text-danger {\n  color: var(--danger-color) !important;\n}\n\n.bg-danger {\n  background-color: var(--danger-color) !important;\n}\n\n.text-warning {\n  color: var(--warning-color) !important;\n}\n\n.bg-warning {\n  background-color: var(--warning-color) !important;\n}\n\n.text-info {\n  color: var(--info-color) !important;\n}\n\n.bg-info {\n  background-color: var(--info-color) !important;\n}\n\n/* Sombras personalizadas */\n.shadow-sm {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.shadow {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Bordes redondeados */\n.rounded-sm {\n  border-radius: 0.25rem !important;\n}\n\n.rounded {\n  border-radius: 0.5rem !important;\n}\n\n.rounded-lg {\n  border-radius: 1rem !important;\n}\n\n.rounded-xl {\n  border-radius: 1.5rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
